import React, { useEffect, useState } from "react";
import { InputBase } from "@mui/material";
import { digitsFaToEn } from "@persian-tools/persian-tools";

export default function Search({ init, setFilter, clearFilter }) {
  const [title, setTitle] = useState(init?.title || "");
  const handleChange = (e) => setTitle(digitsFaToEn(e.target.value));

  useEffect(() => {
    let search = setTimeout(() => {
      if (title) {
        setFilter({ username: title });
      }
    }, 1000);
    return () => clearTimeout(search);
  }, [title]);

  return (
    <InputBase
      autoFocus
      size="small"
      value={title}
      onChange={handleChange}
      placeholder="جستجو..."
      inputProps={{ "aria-label": "جستجو..." }}
      sx={{
        color: "text.secondary",
        bgcolor: "background.paper",
        px: 1,
        py: 0.5,
        borderRadius: 1,
      }}
    />
  );
}
